import { Component } from '@angular/core';

@Component({
  selector: 'app-image-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './image-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class ImageIconComponent {}
